import { useEffect, useState } from 'react';

export const WORKSPACE_HYDRATION_OVERDUE_MS = 30_000;

/**
 * Bound the workspace overlay, without marking either collection loaded.
 *
 * One collection arriving does not renew the deadline or clear an elapsed
 * deadline. The authenticated scope and combined completion define its
 * lifetime; the loader separately requires scoped report metadata or bodies
 * before an elapsed deadline can release navigation.
 */
export function useWorkspaceHydrationDeadline(input: {
  authenticatedUserId: string | null;
  dataPhase: boolean;
  isSitesLoaded: boolean;
  isReportsLoaded: boolean;
}): boolean {
  const { authenticatedUserId, dataPhase, isSitesLoaded, isReportsLoaded } = input;
  const hydrating = Boolean(authenticatedUserId) && dataPhase
    && !(isSitesLoaded && isReportsLoaded);
  const [overdueUserId, setOverdueUserId] = useState<string | null>(null);

  useEffect(() => {
    setOverdueUserId(null);
    if (!hydrating || !authenticatedUserId) return;

    const timer = window.setTimeout(() => {
      console.warn(
        `[AuthGate] workspace hydration still pending after ${WORKSPACE_HYDRATION_OVERDUE_MS}ms; `
        + 'the loader can release when scoped report metadata or bodies are ready.',
      );
      setOverdueUserId(authenticatedUserId);
    }, WORKSPACE_HYDRATION_OVERDUE_MS);
    return () => window.clearTimeout(timer);
  }, [hydrating, authenticatedUserId]);

  return hydrating && overdueUserId === authenticatedUserId;
}
